module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .spl-form__page__upload > div {\n        margin : 5px 0;\n    }\n</style>\n<div class=\"form__page spl-form__page spl-form__page__upload\">\n    <div>\n        <label name=\"data-type\">\n            Тип данных\n            <control type=\"enum-select\" target=\"options.driver\" enum=\"Spatial.ImExDriver\" on-select=\"onDriverSelect\" show-empty=\"true\"/>\n        </label>\n    </div>\n    <div name=\"driver-options\"></div>\n    <div>\n        <label>\n            Файлы для загрузки\n            <input type=\"file\" name=\"files\" multiple on-change=\"onFileChange\"/>\n        </label>\n    </div>\n</div>")
  }
  return __output.join("");

}